import React, { useState, useEffect } from 'react'
import { Row, Col, Panel, IconButton, Icon, Message, Modal, Button } from 'rsuite'
import {
  deleteDolAttachment,
  getDolDownload,
  saveDolAttachment,
} from '../../redux/actions/projectProgress'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { DELETE_ERR_MSG, SAVE_ERR_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { DOL_MEDIA_URL } from '../../config/config'
import DolMultimediaTable from './DolMultimediaTable'

export default function DolMultimediaWidget(props) {
  const { schema } = props
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [progressId, setProgressId] = useState()
  const [formSchema, setFormSchema] = useState(schema)
  const [isEdit, setIsEdit] = useState(false)
  const errMsgCatch = 'Error : DolMultimediaTable '
  const [errorMsg, setErrorMsg] = useState()
  const [saveErr, setSaveErr] = useState()
  const [deleteErr, setDeleteErr] = useState()
  const [isLoading, setIsLoading] = useState()
  const [isDelete, setIsDelete] = useState()
  const [deleteFile, setDeleteFile] = useState()

  const [checkedKeys, setCheckedKeys] = useState([])

  useEffect(() => {
    // setProgressId(location.search.substring(1))
    setProgressId(sessionStorage.getItem('param')?.substring(1))
  }, [location.search])

  useEffect(() => {
    setFormSchema(schema)
  }, [schema])

  const onDownload = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      // const file = await getDolDownload(projectId, progressId, fileObj.url)
      const file = await getDolDownload(projectId, progressId, fileObj.refId)
      console.log('file ', file)
      if (file) {
        const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileObj.name)
        document.body.appendChild(link)
        link.click()
      } else {
        handelSetErrorMsg('error')
      }
    } catch (error) {
      let errorJson = JSON.parse(await error.response.data.text())
      setIsError(true)
      handelSetErrorMsg('error', errorJson?.errors?.message)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const handleCancel = () => {
    setIsEdit(false)
    setCheckedKeys([])
    setSaveErr('')
  }

  const onSave = () => {
    let newArr = []
    let i = 0
    formSchema?.fileItems.map((item) => {
      if (getDataSelected(item.refId)) {
        newArr[i++] = {
          id: item.id,
          projectVersionId: item.projectVersionId,
          projectProgressId: item.projectProgressId,
          label: item.label,
          url: item.url,
          name: item.name,
          path: item.path,
          type: item.type,
          size: item.size,
          refId: item.refId,
          selected: true,
        }
      }
    })
    handleSave(newArr)
  }

  const getDataSelected = (id) => {
    let value = false
    checkedKeys.map((item) => {
      if (item == id) {
        value = true
      }
    })
    return value
  }

  const handleSave = async (request) => {
    setIsLoading(true)
    setSaveErr('')
    try {
      const response = await saveDolAttachment(projectId, progressId, request)
      console.log('response ', response)
      if (response) {
        setFormSchema(response)
      }
      setIsEdit(false)
    } catch (error) {
      console.error(errMsgCatch, error)
      setSaveErr(SAVE_ERR_MSG)
    }

    setIsLoading(false)
  }

  const handleDellete = async () => {
    setIsLoading(true)
    setDeleteErr('')
    try {
      let res = [deleteFile.refId]
      const response = await deleteDolAttachment(projectId, progressId, res)
      console.log('response ', response)
      if (response) {
        setFormSchema(response)
      }
    } catch (error) {
      console.error(errMsgCatch, error)
      setDeleteErr(DELETE_ERR_MSG)
    }

    setIsDelete(false)
    setDeleteFile()
    setIsLoading(false)
  }

  const onDelete = (rowData) => {
    setDeleteFile(rowData)
    setIsDelete(true)
  }

  return (
    <>
      {schema && (
        <Panel shaded header={schema.header} collapsible defaultExpanded>
          <Message
            showIcon
            type="warning"
            description={'กรุณาเลือกสื่อที่ต้องการแนบรายงานความก้าวหน้าในงวดนี้'}
          />
          <br />

          <Row>
            <Button
              onClick={(e) => {
                setCheckedKeys([])
                setIsEdit(true)
              }}
              appearance="primary"
              style={{ marginBottom: 20 }}
              disabled={formSchema.disabled}
            >
              เลือกสื่อจากระบบ DOL
            </Button>
          </Row>

          <Row>
            {errorMsg && (
              <Message
                showIcon
                type={errorMsg.type}
                description={errorMsg.description}
                style={{ marginBottom: 20 }}
              />
            )}

            <DolMultimediaTable
              datas={formSchema?.fileItems?.filter((e) => e.selected) || []}
              disabled={formSchema?.disabled}
              checkedKeys={checkedKeys}
              setCheckedKeys={setCheckedKeys}
              onDownload={onDownload}
              onDelete={onDelete}
              isLoading={isLoading}
              editMode={false}
            />
            {/* <DataTable fileItems={selected} /> */}

            {deleteErr && (
              <Message
                style={{ marginBottom: 10 }}
                showIcon
                type="error"
                description={deleteErr}
                closable
                onClose={() => setDeleteErr('')}
              />
            )}
            <hr />
            <>
              <Row style={{ textAlign: 'right' }}>
                <Col xs={24}>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-info"
                    icon={<Icon icon="external-link" className={'bt-gost-icon-radius-info'} />}
                    onClick={() => window.open(formSchema?.dolUrl, '_blank')}
                  >
                    ไปยังระบบ DOL เพื่อเพิ่มสื่อ
                  </IconButton>
                </Col>
              </Row>
            </>

            <Modal
              show={isEdit}
              size="full"
              onHide={handleCancel}
              //overflow={false}
            >
              <Modal.Header>
                <Modal.Title>เลือกสื่อจากระบบ DOL</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* <DataTable fileItems={unSelected} editMode /> */}
                <DolMultimediaTable
                  datas={formSchema?.fileItems?.filter((e) => !e.selected) || []}
                  disabled={formSchema?.disabled}
                  checkedKeys={checkedKeys}
                  setCheckedKeys={setCheckedKeys}
                  onDownload={onDownload}
                  onDelete={onDelete}
                  isLoading={isLoading}
                  editMode={true}
                />
              </Modal.Body>

              {saveErr && (
                <Message
                  style={{ marginBottom: 10, marginTop: 10 }}
                  showIcon
                  type="error"
                  description={saveErr}
                  closable
                  onClose={() => setSaveErr('')}
                />
              )}
              <Modal.Footer>
                <SaveButton disabled={formSchema.disabled} onClick={onSave}>{`บันทึก`}</SaveButton>
                <CancelButton
                  disabled={formSchema.disabled}
                  onClick={handleCancel}
                >{`ยกเลิก`}</CancelButton>
              </Modal.Footer>
            </Modal>

            <ConfirmWidget
              title={`ยืนยันการลบสื่อ DOL`}
              show={isDelete}
              detail={`ยืนยันการลบสื่อ DOL : ${deleteFile?.name || ''}`}
              onCancle={() => {
                setIsDelete(false)
                setDeleteFile()
              }}
              onConfirm={handleDellete}
            />

            {isLoading && <OverlayLoader />}
          </Row>
        </Panel>
      )}
    </>
  )
}
